/* eslint-disable @typescript-eslint/no-explicit-any */
import Dialog from '@jobseeker/lotus/components/Dialog';
import BottomSheet from '@jobseeker/lotus/elements/BottomSheet';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {
  Box,
  Typography,
  styled,
  FormGroup,
  TextField as BaseTextField,
  FormHelperText,
} from '@mui/material';
import {useState, useRef} from 'react';
import {ButtonV2} from '@jobseeker/lotus/elements';
import Checkbox from '@jobseeker/lotus/elements/CheckBox';
import type {AppState} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';
import Loader from '@jobseeker/lotus/components/Loader';
import InputElement from '@jobseeker/lotus/elements/Input';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import {clone} from 'lodash';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const isAppHirist = process.env.NEXT_PUBLIC_APP_NAME === 'hirist';

const Input = ({InputProps, ...props}: any) => (
  <InputElement
    InputProps={{style: {fontSize: 10}, ...InputProps}}
    variant={VersionVariants.VERSION_TWO}
    sx={{
      mt: 1,
      input: {padding: '12px 16px'},
      // '.MuiInputBase-root': {background: '#F8F8F8'},
    }}
    {...props}
  />
);

const TextField = styled(BaseTextField)(({theme}) => ({
  'textarea::placeholder': {
    fontStyle: 'italic',
  },
  '.MuiInputBase-root': {
    fontSize: 12,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  fieldset: {
    borderColor: '#7E7E7E33',
  },
  '.Mui-focused': {
    '&.Mui-focused fieldset': {
      borderColor: '#333',
      border: '1px solid',
    },
  },
}));

const Component = (props: any) => {
  const [form, setForm] = useState<any>(props.defaultValue ?? {});
  const {isLoggedIn} = useSelector((state: AppState) => state.auth);
  const [error, setError] = useState<any>(false);
  const [emailError, setEmailError] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const [completed, setCompleted] = useState<any>(false);
  const containerBox = useRef<Element | undefined>(undefined);
  const jobDetail = useSelector((state: AppState) => state.jobDetail);

  const setFormValue = (e: any) => {
    const updates: any = {};
    updates[e?.target?.name] = e?.target?.checked;

    if (e.target.name === 'other_comment') {
      updates[e?.target?.name] = e?.target?.value;
    }
    if (e.target.name === 'email') {
      updates[e?.target?.name] = e?.target?.value;
    }
    setForm({...form, ...updates});
    setError(false);
  };

  const onSubmit = async () => {
    let _error = false;
    for (const key in form) {
      if (form[key]) {
        // setError(_error);
        break;
      } else {
        _error = true;
      }
    }

    if (!isLoggedIn && !form['email']) {
      setEmailError(true);
      return;
    }
    if (_error || !Object.keys(form).length) {
      setError(true);
      return;
    }

    if (!form['other_comment'] && form['other']) {
      setError(true);
      return;
    }

    const data = clone(form);
    const reason = Object.keys(data).reduce((prev, curr) => {
      if (typeof data[curr] == 'boolean') {
        return prev + curr + ', ';
      } else return prev;
    }, '');
    data.reason = reason;
    data.jobId = jobDetail.id;

    setLoading(true);
    const resp = await jobDetailService.reportJob(data);
    if (resp && !resp.error) {
      setCompleted(true);
    }
    setLoading(false);
    // setTimeout(() => {
    //   setLoading(false);
    // }, 600);
  };
  // const isLarge = useIsLargeDevice();
  // const WrapperComponent = isLarge ? Dialog : BottomSheet;
  const WrapperComponent: any = Dialog;
  return (
    <WrapperComponent
      title="Report this job"
      subtitle={jobDetail.title}
      variant={props?.variant ?? VersionVariants.VERSION_TWO}
      open={props.open}
      maxWidth={'lg'}
      onClose={() => {
        setTimeout(() => {
          props.onClose();
        }, 0);
      }}
      onDismiss={() => {
        setTimeout(() => {
          props.onClose();
        }, 0);
      }}
    >
      <Box sx={{p: 1}} minWidth={{xxs: 'unset', md: 650}} minHeight={250}>
        <Box
          height={'100%'}
          display={'flex'}
          width={'100%'}
          // minHeight={250}
          ref={containerBox}
        >
          {loading ? (
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              alignContent={'center'}
              width={'100%'}
            >
              <Loader />
            </Box>
          ) : completed ? (
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              alignContent={'center'}
              width={'100%'}
              height={'100%'}
              minHeight={250}
            >
              <Box textAlign={'center'}>
                <Typography fontSize={{xxs: 14, xs: 16}}>
                  Thanks for reporting this job on{' '}
                  {process.env.NEXT_PUBLIC_APP_DOMAIN}.{' '}
                </Typography>
                <Typography fontSize={{xxs: 14, xs: 16}}>
                  We will look into this on top priority.
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box width={'100%'}>
              {!isLoggedIn && (
                <Box mb={3}>
                  <Typography variant="subtitle2">
                    Your Email Address
                  </Typography>
                  <Input
                    name="email"
                    value={form.email}
                    onChange={setFormValue}
                    error={emailError}
                    helperText={emailError && 'Email is required'}
                    placeholder="Please enter your email Address"
                  />
                </Box>
              )}
              <Typography variant="subtitle2">This job is</Typography>
              <FormGroup sx={{mt: 1.5}} onChange={setFormValue}>
                <Checkbox
                  {...(isAppHirist && {
                    variant: VersionVariants.VERSION_HIRIST,
                    sx: {p: 1.125, mr: 1},
                  })}
                  size={16}
                  name="poorly_classified"
                  checked={form.poorly_classified}
                  label={
                    <Typography variant="body2">Poorly Classified</Typography>
                  }
                />
                <Checkbox
                  {...(isAppHirist && {
                    variant: VersionVariants.VERSION_HIRIST,
                    sx: {p: 1.125, mr: 1},
                  })}
                  size={16}
                  name="misleading"
                  checked={form.misleading}
                  label={
                    <Typography variant="body2">
                      Fraudulent/Misleading
                    </Typography>
                  }
                />
                <Checkbox
                  {...(isAppHirist && {
                    variant: VersionVariants.VERSION_HIRIST,
                    sx: {p: 1.125, mr: 1},
                  })}
                  size={16}
                  name="offensive"
                  checked={form.offensive}
                  label={<Typography variant="body2">Offensive</Typography>}
                />
                <Checkbox
                  {...(isAppHirist && {
                    variant: VersionVariants.VERSION_HIRIST,
                    sx: {p: 1.125, mr: 1},
                  })}
                  size={16}
                  name="other"
                  checked={form.other}
                  label={<Typography variant="body2">Other reasons</Typography>}
                />
                {form?.other && (
                  <TextField
                    name={'other_comment'}
                    value={form.other_comment}
                    multiline
                    maxRows={4}
                    inputProps={{}}
                    // error={form.other && !form.other_comment}
                    // helperText={!form.other_comment && 'This is required'}
                    rows={4}
                    placeholder="Add Additional Comments"
                    variant="outlined"
                  />
                )}
              </FormGroup>
              {error && (
                <FormHelperText error={true}>
                  Please select a reason to report this job
                </FormHelperText>
              )}

              <Box display={'flex'} gap={1} mt={3} flexWrap={'wrap'}>
                <ButtonV2
                  onClick={() => {
                    setTimeout(() => {
                      onSubmit();
                    }, 0);
                  }}
                  variant="contained"
                  sx={{
                    width: {xxs: '100%', md: 'fit-content'},
                    background: '#000',
                    ...(isAppHirist && {bgcolor: '#E9630C'}),
                  }}
                >
                  Submit
                </ButtonV2>
                <ButtonV2
                  onClick={() => {
                    setTimeout(() => {
                      props.onClose();
                    }, 0);
                  }}
                  variant="outlined"
                  sx={{
                    width: {xxs: '100%', md: 'fit-content'},
                    borderColor: 'primary',
                  }}
                  color="primary"
                >
                  Cancel
                </ButtonV2>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </WrapperComponent>
  );
};

export default Component;
